export default __webpack_public_path__ + "static/media/PI8000.9e7af422.png";